export const CognitoGroup = {
  AccEditor: 'acc-editor',
  AccViewer: 'acc-viewer',
  HubAdmin: 'admin',
  HubViewer: 'viewer',
} as const;

// eslint-disable-next-line no-redeclare -- intentional value + type pair sharing one name
export type CognitoGroup = (typeof CognitoGroup)[keyof typeof CognitoGroup];

/** Whether `email` belongs to the currently signed-in user (`selfEmail`), case-insensitively. */
export const isSelfUser = (email: string, selfEmail: string): boolean =>
  !!selfEmail && email.toLowerCase() === selfEmail.toLowerCase();

/**
 * Whether removing `email` from `group` would remove the currently signed-in user (`selfEmail`)
 * from the `HubAdmin` group.
 *
 * Used to block admins from removing their own admin access in the UI, but
 * the API still allows admins to remove themselves, and that's acceptable as there is Console access
 * to restore admin rights and this is UX convenience only.
 */
export const isProtectedAdminRemoval = (email: string, group: string | undefined, selfEmail: string): boolean =>
  group === CognitoGroup.HubAdmin && isSelfUser(email, selfEmail);
